export default __webpack_public_path__ + "static/media/dbeb233a-d890-482b-a52d-87e16fca059a.359384f7.png";